import { getCdnLink } from 'tools/getCdnLink';

const IS_DEV = window.stGlobals.env === 'dev';
const cdn = IS_DEV ? 'studyDev' : 'study';
const dimensions = ['standard', 'retina', 'large', 'opengraph'];
const STANDARD = 178;
const RETINA = 356;
const LARGE = 712;

const coverWidth = {
    standard: `${ STANDARD }w`,
    retina: `${ RETINA }w`,
    large: `${ LARGE }w`,
};
const coverPixels = {
    standard: `${ STANDARD }px`,
    retina: `${ RETINA }px`,
    large: `${ LARGE }px`,
};

function getStudyCoverUrl(studyId, dimensionName = null, useCustomCover = false, origin) {
    const hasDimension = dimensions.includes(dimensionName);
    const defaultCoverIdentifier = hasDimension ? `-${ dimensionName }` : 'invalid dimension';
    const customCoverIdentifier = '_cover';
    const imageExtension = '.png';
    const displayedCover = useCustomCover ? customCoverIdentifier : defaultCoverIdentifier;

    return getCdnLink(`${ getFiveThousandBlock(studyId) }/${ studyId }${ displayedCover }${ imageExtension }`, origin ?? cdn);
}

function getFiveThousandBlock(studyId) {
    return Math.floor(studyId / 5000) * 5000;
}

function setStudyCoverSrcset(coverId, isHiResolution = false, isResponsive = false) {

    const queries = ([
        {
            isHiResolution: true,
            dName: 'retina',
            value: '2x',
        },
        {
            isHiResolution: true,
            dName: 'large',
            value: '3x',
        },
        {
            isHiResolution: false,
            dName: 'standard',
        },
        {
            isHiResolution: false,
            dName: 'large',
        },
        {
            isHiResolution: false,
            dName: 'retina',
        },
    ]);
    const hiResSrcset = [], responsiveSrcset = [];
    queries.forEach(query => {
        let currentSrcset = '';
        if (query.isHiResolution) {
            currentSrcset = `${ getStudyCoverUrl(coverId, query.dName, false) } ${ query.value }`;
            hiResSrcset.push(currentSrcset);
        }
        currentSrcset = `${ getStudyCoverUrl(coverId, query.dName, false) } ${ coverWidth[query.dName] }`;
        responsiveSrcset.push(currentSrcset);
    });

    if (isResponsive) {
        return responsiveSrcset.join(', ');
    }

    return isHiResolution ? hiResSrcset.join(' ,') : '';
}

function setResponsiveSizes(setSizes = false, setDefaultStandardSize = false) {
    const breakpoints = {
        s: '412px',
        m: '992px',
    };
    const isStandardDimension = setDefaultStandardSize ? `, ${ coverPixels.standard }` : `, ${ coverPixels.retina }`;
    const responsiveSizes = `(max-width: ${ breakpoints.s }) ${ coverPixels.retina }, (max-width: ${ breakpoints.m }) ${ coverPixels.large }${ isStandardDimension }`;

    return setSizes ? responsiveSizes : '';
}

export { getStudyCoverUrl, getFiveThousandBlock, setStudyCoverSrcset, setResponsiveSizes };
